module.exports = __webpack_public_path__ + "img/Chevron-Right_24px_disable_dark.0eac6882.svg";